import React from 'react';
import dynamic from 'next/dynamic';

const TeaserPromotion = dynamic(() =>
  import('@components/molecules/TeaserPromotion/TeaserPromotion').then((module) => module.TeaserPromotion),
);

export const PageContentElementEntityAd = (element) => {
  if (!element) return null;
  function trackClick() {
    try {
      if (window.fathom) {
        window.fathom.trackEvent('Entity Ad Click');
      } else {
        console.warn('Fathom analytics not available');
      }
    } catch (error) {
      console.error('Error tracking click event:', error);
    }
  }
  return <TeaserPromotion {...element} onCtaClick={trackClick} />;
};

export default PageContentElementEntityAd;
